import Cmd from './Cmd'
import Field from '../components/Field'
import underscorize from './underscorize'
const {assign, keys} = Object

export const toModel = (fieldNames) => (fields) => {
  return fieldNames.reduce( (result, key) =>
    assign({}, result, { [key] : fields[key].value })
  , {})
}

export const fromModel = (fieldDefs) => (model, afterSubmit, errors) =>
  keys(fieldDefs).reduce( (result, field) => {
      const [s, c] = Field.init(assign({}, fieldDefs[field], { errors: errors[field] || [], value: model[field], touched: afterSubmit }))
      return [assign(result[0], { [field]: s }), Cmd.batch(result[1], c) ]
    }, [{}, Cmd.none]
  )

export const assignErrors = (errors, fields) =>
  keys(errors).reduce( (r, key) => {
    const f = assign({}, r[key], { errors: errors[key] })
    return assign({}, r, { [key]: f })
  }, fields)

export const assignValues = (values, fields) =>
  keys(values).reduce( (r, key) => {
    const f = assign({}, r[key], { value: values[key] })
    return assign({}, r, { [key]: f })
  }, fields)


export const isValid = (fields) =>
  keys(fields).filter( (field) => fields[field].errors.length > 0 ).length === 0


export const shouldDisplayErrors = (fields) => {
  return keys(fields).filter( (field) => {
    return fields[field].errors.length > 0 && fields[field].touched
  }).length > 0
}


// export default {
//   toModel,
//   fromModel,
//   assignErrors,
//   fieldError
// }
